<h2 mat-dialog-title>Two-Factor Auth Code</h2>

<span mat-dialog-close class="btn-mat-dialog-close">
  <img src="assets/images/close-icon-gray.svg" alt="Close" title="Close" />
</span>

<mat-dialog-content>
  <form [formGroup]="form" (keydown.enter)="verifyCode()">
    <div class="code-input-container">
      <label class="code-label">Verification Code</label>
      <div class="boxes-wrapper">
        <input #digitInput type="text" formControlName="digit1" maxlength="1" class="code-box"
          (input)="onInput($event, 0)" (keydown)="onKeyDown($event, 0)" (paste)="onPaste($event)"
          autocomplete="off" />
        <input #digitInput type="text" formControlName="digit2" maxlength="1" class="code-box"
          (input)="onInput($event, 1)" (keydown)="onKeyDown($event, 1)" autocomplete="off" />
        <input #digitInput type="text" formControlName="digit3" maxlength="1" class="code-box"
          (input)="onInput($event, 2)" (keydown)="onKeyDown($event, 2)" autocomplete="off" />
        <input #digitInput type="text" formControlName="digit4" maxlength="1" class="code-box"
          (input)="onInput($event, 3)" (keydown)="onKeyDown($event, 3)" autocomplete="off" />
        <input #digitInput type="text" formControlName="digit5" maxlength="1" class="code-box"
          (input)="onInput($event, 4)" (keydown)="onKeyDown($event, 4)" autocomplete="off" />
        <input #digitInput type="text" formControlName="digit6" maxlength="1" class="code-box"
          (input)="onInput($event, 5)" (keydown)="onKeyDown($event, 5)" autocomplete="off" />
      </div>
      <mat-error *ngIf="form.invalid && form.touched" class="error-msg">
        Code is required
      </mat-error>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-flat-button color="primary" (click)="verifyCode()">Submit</button>
</mat-dialog-actions>